import { HttpLoaderFactory, SharedModule } from './../../shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyJourneyRoutingModule } from './my-journey-routing.module';
import { MyJourneyComponent } from './components/my-journey/my-journey.component';
import { DynamicControlsModule } from 'src/app/controls/dynamic-controls.module';
import { AngularMaterialModule } from 'src/app/material.module';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { OnboardingManagerComponent } from './components/onboarding-manager/onboarding-manager.component';
import { OnboardingDetailsComponent } from './components/onboarding-details/onboarding-details.component';
import { ApplicantFeedbackComponent } from './components/applicant-feedback/applicant-feedback.component';
import { AppointmentDetailsComponent } from './components/appointment-details/appointment-details.component';
import { PreOfferComponent } from './components/pre-offer/pre-offer.component';
import { OfferDetailsComponent } from './components/offer-details/offer-details.component';
import { OfferOnbFieldDetailsComponent } from './components/offer-onb-field-details/offer-onb-field-details.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';


@NgModule({
  declarations: [
    MyJourneyComponent,
    OnboardingManagerComponent,
    OnboardingDetailsComponent,
    PreOfferComponent,
    AppointmentDetailsComponent,
    ApplicantFeedbackComponent,
    OfferDetailsComponent,
    OfferOnbFieldDetailsComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    MyJourneyRoutingModule,
    SharedModule,
    DynamicControlsModule,
    NgxDocViewerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ]
})
export class MyJourneyModule { }
